import React, { useEffect, useState } from "react";
import {
  Form,
  Button,
  Tabs,
  Space,
  Card,
  Popconfirm,
  message,
  Select,
  Row,
  Col,
} from "antd";
import { API_METHODS, BLANK_VALUE } from "../../constants";
import useApi from "../../hooks/useApi";
import TableComponent from "../common/table/TableComponent";
import { EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

function TestTable() {
  const [activeTab, setActiveTab] = useState(1);
  const [subscriptionFilter, setSubscriptionFilter] = useState(2);
  const [confirmDeletePCLoading, setConfirmDeletePCLoading] = useState(false);
  const navigate = useNavigate();
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Total Time",
      dataIndex: "total_time",
    },
    {
      title: "Month",
      dataIndex: "month",
    },
    {
      title: "Week",
      dataIndex: "week",
    },
    {
      title: "Date",
      dataIndex: "date",
    },
    {
      title: "Free",
      dataIndex: "is_free",
      render: (text) => (text == true ? "Yes" : "No"),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space>
          <Button size="small" onClick={() => viewtest(record)}>
            <EyeOutlined />
          </Button>
          {activeTab != 5 && (
            <>
              <Button size="small" onClick={() => uploadImages(record)}>
                Upload Images
              </Button>
              <Popconfirm
                title="Delete Test"
                description={`Are you sure to delete this test?`}
                onConfirm={() => deleteOk(record)}
                trigger={"click"}
                okButtonProps={{
                  loading: confirmDeletePCLoading,
                }}
                placement="rightTop"
              >
                <Button size="small">
                  <DeleteOutlined style={{ color: "red" }} />
                </Button>
              </Popconfirm>
            </>
          )}
        </Space>
      ),
    },
  ];

  const viewtest = (record) => {
    navigate(`/portal/test/view/${record.id}`);
  };

  const uploadImages = (record) => {
    navigate(`/portal/test/upload-images/${record.id}`);
  };

  const [responseData, getRequest] = useApi(
    `/admin/test?pageNumber=1&test_type=1&subscription_id=2`,
    null,
    API_METHODS.GET
  );

  const [deletedTestResponse, deletedTestRequest] = useApi(
    `/admin/test/deleted?pageNumber=1`,
    null,
    API_METHODS.GET
  );
  const [deleteResponse, deleteRequest] = useApi();

  const [tableData, setTableData] = useState();
  const [form] = Form.useForm();
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    getRequest();
  }, []);

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    const pagination =
      responseData.pagination !== BLANK_VALUE ? responseData.pagination : {};
    setTableData(data);
    setTotalRecords(pagination ? pagination.count : 0);
  }, [responseData]);

  useEffect(() => {
    const data =
      deletedTestResponse.data !== BLANK_VALUE ? deletedTestResponse.data : [];
    const pagination =
      deletedTestResponse.pagination !== BLANK_VALUE
        ? deletedTestResponse.pagination
        : {};
    setTableData(data);
    setTotalRecords(pagination ? pagination.count : 0);
  }, [deletedTestResponse]);

  useEffect(() => {
    if (deleteResponse.data && !deleteResponse.isLoading) {
      // Reset to first tab with default subscription filter
      setActiveTab(1);
      setSubscriptionFilter(2);
      setCurrentPage(1);
      getRequest(
        null,
        API_METHODS.GET,
        `/admin/test?pageNumber=1&test_type=1&subscription_id=2`
      );
      messageApi.open({
        type: "success",
        content: "Test Deleted successfully",
      });
      setConfirmDeletePCLoading(false);
    }
  }, [deleteResponse]);

  const deleteOk = (record) => {
    setConfirmDeletePCLoading(true);
    deleteRequest(null, API_METHODS.DELETE, `/admin/test/${record.id}`);
  };

  const onPaginationChange = (page) => {
    if (activeTab == 5) {
      deletedTestRequest(
        null,
        API_METHODS.GET,
        `/admin/test/deleted?pageNumber=${page.current}`
      );
    } else if (activeTab == 4) {
      getRequest(
        null,
        API_METHODS.GET,
        `/admin/test?pageNumber=${page.current}&test_type=${activeTab}`
      );
    } else {
      getRequest(
        null,
        API_METHODS.GET,
        `/admin/test?pageNumber=${page.current}&test_type=${activeTab}&subscription_id=${subscriptionFilter}`
      );
    }
    setCurrentPage(page.current);
  };

  const onTabChange = (key) => {
    setActiveTab(key);
    setSubscriptionFilter(2); // Reset to default subscription filter
    setCurrentPage(1);
    form.resetFields();

    if (key == 5) {
      deletedTestRequest(
        null,
        API_METHODS.GET,
        `/admin/test/deleted?pageNumber=1`
      );
    } else if (key == 4) {
      getRequest(
        null,
        API_METHODS.GET,
        `/admin/test?pageNumber=1&test_type=${key}`
      );
    } else {
      getRequest(
        null,
        API_METHODS.GET,
        `/admin/test?pageNumber=1&test_type=${key}&subscription_id=2`
      );
    }
  };

  const onSubscriptionFilterChange = (value) => {
    setSubscriptionFilter(value);
    setCurrentPage(1);
    getRequest(
      null,
      API_METHODS.GET,
      `/admin/test?pageNumber=1&test_type=${activeTab}&subscription_id=${value}`
    );
  };

  const handleAddTest = () => {
    navigate("/portal/test/upload");
  };

  const items = [
    {
      key: 1,
      label: "Weekly",
      children: (
        <>
          {activeTab !== 4 && activeTab !== 5 && (
            <Row gutter={16} style={{ marginBottom: 16 }}>
              <Col span={6}>
                <Select
                  value={subscriptionFilter}
                  onChange={onSubscriptionFilterChange}
                  style={{ width: "100%" }}
                  options={[
                    {
                      value: 2,
                      label: "GPAT Basic",
                    },
                    {
                      value: 3,
                      label: "GPAT Advance",
                    },
                  ]}
                />
              </Col>
            </Row>
          )}
          <TableComponent
            columns={columns}
            tableData={tableData}
            loading={responseData.isLoading}
            onPaginationChange={onPaginationChange}
            total={totalRecords}
            current={currentPage}
          />
        </>
      ),
    },
    {
      key: 2,
      label: "Monthly",
      children: (
        <>
          {activeTab !== 4 && activeTab !== 5 && (
            <Row gutter={16} style={{ marginBottom: 16 }}>
              <Col span={6}>
                <Select
                  value={subscriptionFilter}
                  onChange={onSubscriptionFilterChange}
                  style={{ width: "100%" }}
                  options={[
                    {
                      value: 2,
                      label: "GPAT Basic",
                    },
                    {
                      value: 3,
                      label: "GPAT Advance",
                    },
                  ]}
                />
              </Col>
            </Row>
          )}
          <TableComponent
            columns={columns}
            tableData={tableData}
            loading={responseData.isLoading}
            onPaginationChange={onPaginationChange}
            total={totalRecords}
            current={currentPage}
          />
        </>
      ),
    },
    {
      key: 3,
      label: "Mock",
      children: (
        <>
          {activeTab !== 4 && activeTab !== 5 && (
            <Row gutter={16} style={{ marginBottom: 16 }}>
              <Col span={6}>
                <Select
                  value={subscriptionFilter}
                  onChange={onSubscriptionFilterChange}
                  style={{ width: "100%" }}
                  options={[
                    {
                      value: 2,
                      label: "GPAT Basic",
                    },
                    {
                      value: 3,
                      label: "GPAT Advance",
                    },
                  ]}
                />
              </Col>
            </Row>
          )}
          <TableComponent
            columns={columns}
            tableData={tableData}
            loading={responseData.isLoading}
            onPaginationChange={onPaginationChange}
            total={totalRecords}
            current={currentPage}
          />
        </>
      ),
    },
    {
      key: 4,
      label: "Practice MCQ",
      children: (
        <TableComponent
          columns={columns}
          tableData={tableData}
          loading={responseData.isLoading}
          onPaginationChange={onPaginationChange}
          total={totalRecords}
          current={currentPage}
        />
      ),
    },
    {
      key: 5,
      label: "Deleted Tests",
      children: (
        <TableComponent
          columns={columns}
          tableData={tableData}
          loading={responseData.isLoading}
          onPaginationChange={onPaginationChange}
          total={totalRecords}
          current={currentPage}
        />
      ),
    },
  ];

  return (
    <Card
      title="Uploaded Tests"
      extra={
        <Button type="primary" onClick={handleAddTest}>
          Upload Tests
        </Button>
      }
    >
      {contextHolder}
      <Tabs
        defaultActiveKey="1"
        activeKey={activeTab}
        items={items}
        onChange={onTabChange}
      />
    </Card>
  );
}

export default TestTable;
